import React, { createContext, useState } from 'react';

import './App.css';
import ErrorBoundary from './components/Error/ErrorBoundary';
import ErrorFallback from './components/Error/ErrorFallback';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import Banner from './components/Banner/Banner';
import OpenIdVcRequestQR from './components/Auth/OpenIdVcRequestQR';
import FaceCapturePage from './components/Face/FaceCapturePage';
import {
  UiPreviewMenu,
  UiPreviewShortcut,
  UiPreviewState,
} from './components/Preview/UiPreview';
import { isUiPreviewEnabled } from './config';

export const BannerContext = createContext(() => { });

function ErrorElement() {
  // /error로 navigate할 때 전달한 state.message를 ErrorFallback에 전달
  const { state } = useLocation();
  const navigate = useNavigate();
  return (
    <ErrorFallback
      message={state?.message}
      onRetry={() => navigate('/', { replace: true })}
    />
  );
}

function AppRoutes() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const previewState = searchParams.get('preview');
  const previewEnabled = isUiPreviewEnabled();

  if (previewEnabled && previewState) {
    return previewState === 'menu' ? (
      <UiPreviewMenu />
    ) : (
      <UiPreviewState stateId={previewState} />
    );
  }

  return (
    <>
      <Routes>
        <Route path='/' element={<OpenIdVcRequestQR />} />
        <Route path='/face-capture' element={<FaceCapturePage />} />
        <Route path='/error' element={<ErrorElement />} />
      </Routes>
      {previewEnabled && location.pathname === '/' && <UiPreviewShortcut />}
    </>
  );
}

function App() {
  const [bannerText, setBannerText] = useState('화면의 QR 코드를 Wallet 앱으로 찍으세요!');

  const handleErrorReset = () => {
    window.location.reload();
  };

  return (
    <Router>
      <BannerContext.Provider value={setBannerText}>
        <div className="verifier-QR-scan">
          <div className="gradation_1"></div>
          <div className="gradation_2"></div>

          <div className="issuer-header">
            <p className="UXM-verifier">
              <span className="UXM">UXM </span>
              <span className="Verifier">Verifier</span>
            </p>
          </div>

          <Banner text={bannerText} />

          <ErrorBoundary FallbackComponent={ErrorFallback} onReset={handleErrorReset}>
            <AppRoutes />
          </ErrorBoundary>
        </div>
      </BannerContext.Provider>
    </Router>
  );
}

export default App;
